/**
 * @file utils/clearance.ts
 * Habilitation aux données (classification C1 < C2 < C3 < C4).
 *
 * Reflète `DataClearance.allows` du backend : un utilisateur accède à une donnée
 * si le niveau de sa clearance est >= au niveau de classification de la donnée.
 */
import type { DataClearance } from '@assistia/sdk';

export const CLEARANCE_LEVEL: Record<DataClearance, number> = {
  C1: 1,
  C2: 2,
  C3: 3,
  C4: 4,
};

export const CLEARANCE_LABEL: Record<DataClearance, string> = {
  C1: 'C1 — Public',
  C2: 'C2 — Interne',
  C3: 'C3 — Sensible',
  C4: 'C4 — Médical / ANSSI',
};

/** True si la clearance utilisateur permet l'accès à `dataLevel`. */
export function clearanceAllows(
  userClearance: DataClearance | null,
  dataLevel: DataClearance,
): boolean {
  if (!userClearance) return false;
  return CLEARANCE_LEVEL[userClearance] >= CLEARANCE_LEVEL[dataLevel];
}

/** Extrait un niveau C1–C4 d'une chaîne de classification (ex. "C2 - Interne"). */
export function parseClearance(value: string | null | undefined): DataClearance | null {
  if (!value) return null;
  const match = /\bC([1-4])\b/i.exec(value);
  return match ? (`C${match[1]}` as DataClearance) : null;
}
